var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{
    'help-block': true,
    'mb-0': _vm.noBottomMargin,
    'mt-0': _vm.noTopMargin,
}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }